import React, { Component } from 'react';
import { navigate } from '@reach/router';

type SettingsProps = {
  children: string,
  user?: any
};

class Settings extends Component<SettingsProps> {
  static defaultProps = {
    user: {}
  };

  componentDidUpdate() {
    const { user } = this.props;
    if (user && user.role === 'ED') {
      navigate(`/admin/incidents/public`);
    }
  }

  render() {
    const { children } = this.props;
    return <>{children}</>;
  }
}

export default Settings;
